/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { __awaiter, __extends, __generator } from "tslib";
import * as runtime from '../runtime';
import { EchoResponseFromJSON, } from '../models';
/**
 *
 */
var EchoServiceApi = /** @class */ (function (_super) {
    __extends(EchoServiceApi, _super);
    function EchoServiceApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * This end point returns the same massage as specified in \'message\' parameter.<br> <br> This end point has no access restriction and publicly accessible.
     * This end point returns the same massage as specified in \'message\' parameter.
     */
    EchoServiceApi.prototype.getEchoRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.message !== undefined) {
                            queryParameters['message'] = requestParameters.message;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("keycloak", [])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/echo",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return EchoResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * This end point returns the same massage as specified in \'message\' parameter.<br> <br> This end point has no access restriction and publicly accessible.
     * This end point returns the same massage as specified in \'message\' parameter.
     */
    EchoServiceApi.prototype.getEcho = function (requestParameters, initOverrides) {
        if (requestParameters === void 0) { requestParameters = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getEchoRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return EchoServiceApi;
}(runtime.BaseAPI));
export { EchoServiceApi };
